export const root = "r4m3rky";
export const cards = "c19qw1jw";
export const loader = "l1eng0f3";
export const wrapper = "wdtw9rj";
export const tethered = "t132e8u4";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");